import React, { Component } from "react";
import { connect } from "react-redux";
import { userDetail } from "../../config/userDetails";
import TabsConstants from "../../constants";
import "../../style";
import Forbidden from "../../template/private/Forbidden";
import { hasValidPlan, isAuthorized } from "../Common/CheckAuthorization";
import SubMenu from "../private/SubMenu";
import InternalTickets from "./RiskManagement/InternalTickets";
import RiskMgmtView from "./RiskManagement/RiskMgmtView";
import UnallocatedTickets from "./RiskManagement/UnallocatedTickets";

const CHILD_ROUTES = {
  CONTRACTED_MGMT: "contracted-mgmt",
  UNALLOCATED_MGMT: "unallocated-mgmt",
  INTERNAL_MGMT: "inventory-mgmt"
};

class RiskManagement extends Component {
  state = { activeTabValue: "" };
  componentWillMount() {
    this.setStateBasedOnRoutes(this.props);
  }

  setStateBasedOnRoutes = props => {
    const params = props.route.match.params;
    const segment0 = Object.keys(params).length > 0 ? params["0"] : null;
    const path = this.props.route.match.path;
    this.setState({ children: path });
    if (segment0 && segment0.indexOf(CHILD_ROUTES.INTERNAL_MGMT) !== -1) {
      this.setState({
        activeTabValue: CHILD_ROUTES.INTERNAL_MGMT,
        children: CHILD_ROUTES.INTERNAL_MGMT
      });
    } else if (
      segment0 &&
      segment0.indexOf(CHILD_ROUTES.UNALLOCATED_MGMT) !== -1
    ) {
      this.setState({
        activeTabValue: CHILD_ROUTES.UNALLOCATED_MGMT,
        children: CHILD_ROUTES.UNALLOCATED_MGMT
      });
    } else {
      this.setState({
        activeTabValue: CHILD_ROUTES.CONTRACTED_MGMT,
        children: CHILD_ROUTES.CONTRACTED_MGMT
      });
    }
  };

  componentWillReceiveProps(props) {
    this.setStateBasedOnRoutes(props);
  }

  render() {
    const menuName = "Risk management";
    const { activeTabValue, children } = this.state;
    const { RiskManagementScreen } = TabsConstants;
    return isAuthorized() && hasValidPlan() ? (
      <div className="">
        <SubMenu
          menuName={menuName}
          tabsVisible={RiskManagementScreen[userDetail().roleName]}
          routes={this.props.route}
          activeTabValue={activeTabValue}
          handleChangeTabBody={this.updateTabBody}
        />
        {children === CHILD_ROUTES.CONTRACTED_MGMT && <RiskMgmtView />}
        {children === CHILD_ROUTES.UNALLOCATED_MGMT && <UnallocatedTickets />}
        {children === CHILD_ROUTES.INTERNAL_MGMT && <InternalTickets />}
      </div>
    ) : (
      <Forbidden />
    );
  }
}
export default connect(
  null,
  {}
)(RiskManagement);



// WEBPACK FOOTER //
// ./src/components/private/RiskManagement.js